import { TaskData } from '../../../models';
import { useState } from 'react';
import liff from '@line/liff';
import ReactTooltip from 'react-tooltip';
import { FeedbackCard } from './FeedbackCard';
import { useTranslation } from 'react-i18next';

const getImageContent = (url: string, feedback: string) => {
  return {
    type: 'bubble',
    hero: {
      type: 'image',
      url,
      size: 'full',
      aspectMode: 'fit',
    },
    body: {
      type: 'box',
      layout: 'vertical',
      contents: [
        {
          type: 'box',
          layout: 'vertical',
          contents: [
            {
              type: 'text',
              text: '組長小叮嚀：',
              weight: 'bold',
            },
            {
              type: 'text',
              text: feedback,
              wrap: true,
            },
          ],
          backgroundColor: '#FFFFFF',
          paddingTop: '4px',
          paddingBottom: '4px',
          paddingStart: '12px',
          paddingEnd: '12px',
          cornerRadius: '8px',
        },
      ],
      backgroundColor: '#54A178',
      paddingAll: '12px',
    },
  };
};

const getTextContent = (question: string, answer: string, feedback: string) => {
  return {
    type: 'bubble',
    hero: {
      type: 'box',
      layout: 'vertical',
      contents: [
        {
          type: 'text',
          text: `Q: ${question}`,
          wrap: true,
        },
        {
          type: 'text',
          text: `A: ${answer}`,
          wrap: true,
          weight: 'bold',
        },
      ],
      paddingAll: '12px',
      backgroundColor: '#F0F0F0',
    },
    body: {
      type: 'box',
      layout: 'vertical',
      contents: [
        {
          type: 'box',
          layout: 'vertical',
          contents: [
            {
              type: 'text',
              text: '組長小叮嚀：',
              weight: 'bold',
            },
            {
              type: 'text',
              text: feedback,
              wrap: true,
            },
          ],
          backgroundColor: '#FFFFFF',
          paddingTop: '4px',
          paddingBottom: '4px',
          paddingStart: '12px',
          paddingEnd: '12px',
          cornerRadius: '8px',
        },
      ],
      backgroundColor: '#54A178',
      paddingAll: '12px',
    },
  };
};

export type ShareFeedbackModalProps = {
  taskData: TaskData;
  handleCloseClick: () => void;
};

export function ShareFeedbackModal({
  taskData,
  handleCloseClick,
}: ShareFeedbackModalProps) {
  const [t] = useTranslation(['common']);
  const [sharedRef, setSharedRef] = useState<any>();

  const handleShareClick = () => {
    const { question, answer, type, feedback } = taskData;
    const contents =
      type === 'image'
        ? getImageContent(answer, feedback || '')
        : getTextContent(question, answer, feedback || '');

    liff
      .shareTargetPicker([
        {
          type: 'flex',
          altText: '您收到了一則組長小叮嚀！',
          // LIFF SDK type definition issues
          // @ts-ignore
          contents,
        },
      ])
      .then((res) => {
        if (!sharedRef || !res) {
          return;
        }

        if (res.status) {
          ReactTooltip.show(sharedRef);
          setTimeout(() => {
            ReactTooltip.hide(sharedRef);
          }, 1500);
        }
      });
  };

  return (
    <div className="bg-white flex flex-col p-4 w-full">
      <span
        className="material-symbols-outlined text-manage-primary text text-end font-extrabold mb-6"
        onClick={handleCloseClick}
      >
        close
      </span>
      <div className="flex flex-col w-full h-full gap-5">
        <span className="flex flex-grow justify-center text-xl font-bold text-manage-primary">
          {t('saved', '儲存成功！')}
        </span>
        <FeedbackCard taskData={taskData} />
        <button
          data-for="shareTooltip"
          data-tip="shared!"
          data-event="none"
          ref={setSharedRef}
          className="bg-manage-sub rounded text-white text-lg py-3"
          onClick={handleShareClick}
        >
          {t('share', '分享')}
        </button>
        <ReactTooltip id="shareTooltip" />
      </div>
    </div>
  );
}
